import request from "@/utils/requset"

// 获取oss信息接口
export function getOssTempToken(data) {
  return request({
    url: "/upload/getOssTempToken",
    method: "post",
    data: data,
  });
}
// //提交接口
// export function returnWarehouseImg(data) {
//   return request({
//     url: "/oyraswk/returnWarehouseImg/addWarehouseImg",
//     method: "post",
//     data: data,
//   });
// }

//提交接口-售后
export function returnWarehouseImg(data) {
  return request({
    url: "/oyraswk/salesOutboundImg/add",
    method: "post",
    data: data,
  });
}
//提交接口-杨江
export function returnWarehouseImg2(data) {
  return request({
    url: "/oyraswk/shipVoucher",
    method: "post",
    data: data,
  });
}
// 查询旺店通店铺接口
export function shoplist(query) {
  return request({
    url: "/oyraswk/shop/list",
    method: "get",
    params: query,
  });
}

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}